module.exports = __webpack_public_path__ + "img/menu8.2ff91b8d.png";